import React from 'react';
import { motion } from 'framer-motion';

const timeOffData = [
    {
        id: 1,
        title: "Paid time off (PTO)",
        description: "We believe everyone needs time to rest, recharge, and take care of personal matters. That's why you'll receive paid time off (PTO) each year, based on your state’s regulations, including earned leave, sick leave, and casual leave."
    },
    {
        id: 2,
        title: "Public Holidays",
        description: "We believe time off matters. That’s why you’ll enjoy 10 paid public holidays each year, including 8 fixed holidays and 2 flexible floating holidays to celebrate what’s important to you."
    }
];

const YourTimeOffSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="text-center mb-[24px] md:mb-[60px]"
                >
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Your time off
                    </h2>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 md:grid-cols-2 gap-[16px] md:gap-[30px]"
                >
                    {timeOffData.map((item) => (
                        <motion.div
                            key={item.id}
                            variants={fadeUpVariant}
                            className="group relative flex flex-col bg-white border border-[#E4E8F5] p-[24px] sm:p-[30px] md:p-[40px] h-full min-h-[200px] sm:min-h-[250px] shadow-sm hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-shadow duration-300 overflow-hidden"
                        >
                            <div className="flex flex-col h-full z-10">
                                <h3 className="text-[16px] md:text-[20px] font-[600] text-[#01386A] font-sora mb-[20px] sm:mb-[40px] md:mb-[60px] transition-transform duration-300 transform md:group-hover:-translate-y-1">
                                    {item.title}
                                </h3>

                                <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6] md:leading-[1.7] mt-auto">
                                    {item.description}
                                </p>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-20"></div>

                            <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#F97316] transition-all duration-500 ease-out group-hover:w-full z-30"></div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default YourTimeOffSection;